import { Link } from "react-router-dom";
import { workData } from "../Data.js";
import "./works.scss";

export default function Works() {
  return (
    <section className="works" id="works">
      <div className="works__inner">
        <h2 className="works__pageTitle">My Projects</h2>
        <p className="works__subtitle">Explore my recent work and design process</p>
        <div className="works__grid">
          {workData.map((project) => {
            const rawImg = project.steps.find(step => step.img)?.img || "";
            const projectImage = Array.isArray(rawImg) ? rawImg[0] : rawImg;
            return (
              <div key={project.id} className="works__card">
                {projectImage && (
                  <div className="works__imageContainer">
                    <img 
                      src={projectImage} 
                      alt={project.title}
                      className="works__image"
                    />
                  </div>
                )}
                
                <div className="works__content">
                  <h3 className="works__cardTitle">{project.title}</h3>
                  
                  <div className="works__tags">
                    {project.skills.map((skill, index) => (
                      <span key={index} className="works__tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                  
                  <p className="works__description">
                    {project.brief || project.steps[0]?.desc || "No description available."}
                  </p>
                  
                  <Link 
                    to={`/my-portfolio#${project.id}`}
                    className="works__button"
                  >
                    View Project
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
